/**
 * Utils for dealing with validation errors
 */

import {isArray, isObject} from "lodash";
import handleAjaxErrorV2 from "../../handleAjaxErrorV2";
import {waitUntil} from "../../waitUntil";

// noinspection JSUnusedGlobalSymbols imported via d.ts file
/**
 * Checks if the error contains an array element validation error type by
 * checking for the given filter and calling the corresponding handler
 *
 * @param {any} error
 * @param {ValidationFilter[]} filters
 */
function interceptValidationErrors(error, filters) {
    // Check if axios response
    let interceptedSomething = false;

    if (error.response) {
        // Check if we got data and errors fields
        if (error.response.data && error.response.data.errors) {
            if (isObject(error.response.data.errors)) {
                Object.keys(error.response.data.errors).forEach(errorKey => {
                    // Check if one of the filters matches the error key
                    filters.forEach(filter => {
                        if (filter.pattern.test(errorKey)) {
                            // Pattern matches, execute filter
                            let errorMessage = error.response.data.errors[errorKey];

                            if (isArray(errorMessage)) {
                                errorMessage = errorMessage[0];
                            }

                            filter.handler(errorKey, errorMessage);

                            // Remove error from response
                            delete error.response.data.errors[errorKey];

                            interceptedSomething = true;
                        }
                    })
                })
            }
        }
    }

    return interceptedSomething;
}

// noinspection JSUnusedGlobalSymbols imported from d.ts file
function noValidationErrorsLeft(error) {
    if (error.response) {
        // Check if we got data and errors fields
        if (error.response.data && error.response.data.errors) {
            if (isObject(error.response.data.errors)) {
                return Object.keys(error.response.data.errors).length === 0;
            }
        }
    }

    return true;
}

// noinspection JSUnusedGlobalSymbols -- imported via d.ts
/**
 * Takes care of calling handleAjaxError to simulate a server validation
 * error for the given field/input name
 *
 * @param {Element} formContainer
 * @param {string} field
 * @param {string} error
 */
function displayLocalValidationError(formContainer, field, error) {
    handleAjaxErrorV2(
        {
            response: {
                data: {
                    errors: {
                        [field]: [error],
                    }
                }
            }
        },
        formContainer
    )
}

function displayLocalValidationErrorPromise(formContainer, field, error) {
    displayLocalValidationError(formContainer, field, error);

    // Wait until popup is gone
    return new Promise((resolve) => {
        setTimeout(() => {
            waitUntil(() => {
                return document.querySelector('.swal2-popup.swal2-show') === null
            }).then(() => {
                resolve();
            })
        }, 128)
    })
}

export {
    interceptValidationErrors,
    noValidationErrorsLeft,
    displayLocalValidationError,
    displayLocalValidationErrorPromise
}
